<p-menubar [dt]="menubarHeaderDesignToken" [model]="items" [breakpoint]="'0px'">
	<ng-template #start>
		<a routerLink="/vehicles">
			<div class="title desktop-only">{{ title }}</div>
			<i class="pi pi-home mobile-only title-icon"></i>
		</a>
	</ng-template>
	<ng-template #item let-item>
		@if (item.routerLink) {
			<a [routerLink]="item.routerLink" routerLinkActive="active-nav-link" class="p-menubar-item-link">
				@if (item.icon) {
					<i class="{{ item.icon }}"></i>
				}
				<span class="ml-2">{{ item.label }}</span>
			</a>
		} @else {
			<span class="p-menubar-item-link">
				@if (item.icon) {
					<i class="{{ item.icon }}"></i>
				}
				<span class="ml-2">{{ item.label }}</span>
			</span>
		}
	</ng-template>
	<ng-template #end>
		<div class="end-items">
			@if (themeService.theme$ | async; as theme) {
				<p-button [rounded]="true" [outlined]="true" [icon]="theme === Theme.Light ? 'pi pi-sun' : 'pi pi-moon'" (onClick)="themeService.toggleTheme()"></p-button>
			}
			<p-menu #menu [popup]="true">
				<ng-template pTemplate="start">
					@if (authService.userData$ | async; as userData) {
						<div class="session-content">
							@if (!!userData.sessionID) {
								<div>
									<b>{{ userData.userName }}</b>
								</div>
								<div>{{ userData.companyName }}</div>
								<p-button icon="pi pi-sign-out" label="Sign out" (click)="authService.clearSession(true)"></p-button>
							} @else {
								<p-button icon="pi pi-sign-in" label="Sign in" (click)="authService.login()"></p-button>
							}
						</div>
					}
				</ng-template>
			</p-menu>
			<div class="user-icon-container" style="cursor: pointer" (click)="menu.toggle($event)" (keydown)="authService.login()" tabindex="0">
				<img class="user-icon" alt="Signed in user icon" src="https://www.svgrepo.com/show/384671/account-avatar-profile-user-14.svg" />
			</div>
		</div>
	</ng-template>
</p-menubar>
